import { mapState } from 'vuex';
import select from 'dom-select';

/**
 * Product card slider component
 */
export default {
  props: ['categories'],
  data() {
    return {
      catItems: [],
      afterLoaded: false,
    };
  },
  beforeMount() {
    const categories = this.categories.split(',');
    for (const i in categories) {
      this.catItems.push({
        value: categories[i].toLowerCase().replace(' ', '-'),
        label: categories[i],
      });
    }

    this.$store.commit('shadeFinder/setActiveCategory', this.catItems[0].value);
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  computed: {
    ...mapState('shadeFinder', ['activeCategory']),
  },
  methods: {
    handleScroll() {
      let cur = this.catItems.filter((item) => {
        const gridOffset = select('.sf-results-grid').offsetTop;
        const block = select(`#sf-results-block-${item.value}`);
        let posY = gridOffset + block.offsetTop - 160;
        if (item.value === 'foundation') {
          posY = block.offsetTop - 65;
        }
        if (window.innerWidth < 1024) {
          posY -= 50;
        }

        if (posY <= window.scrollY + window.innerHeight / 2) {
          return item;
        }
      });

      this.afterLoaded = false;
      if (cur.length > 0) {
        cur = cur[cur.length - 1];
        this.$store.commit('shadeFinder/setActiveCategory', cur.value);

        if (select('#sf-results-nav-select')) {
          select('#sf-results-nav-select').value = cur.value;
        }
        setTimeout(() => {
          this.afterLoaded = true;
        }, 100);
      } else {
        if (select('#sf-results-nav-select')) {
          select('#sf-results-nav-select').value = 'foundation';
        }
        setTimeout(() => {
          this.afterLoaded = true;
        }, 100);
      }
    },
    selectCategory(cat) {
      this.$store.commit('shadeFinder/setActiveCategory', cat);
      this.scrollToSection(cat);
    },
    scrollToSection(cat) {
      const gridOffset = select('.sf-results-grid').offsetTop;
      const block = select(`#sf-results-block-${cat}`);
      let posY = gridOffset + block.offsetTop - 160;
      if (cat === 'foundation') {
        posY = block.offsetTop - 65;
      }
      if (window.innerWidth < 1024) {
        posY -= 50;
      }
      window.scrollTo(0, posY);
    },
    generateItemArray() {
      let items = [
        {
          label: 'foundation',
          value: 'foundation',
        },
      ];
      items = items.concat(this.catItems);
      return items;
    },
    getInitialValue() {
      return 'foundation';
    },
    onInputChange(item) {
      if (this.afterLoaded) {
        this.scrollToSection(item.value);
      }
      this.afterLoaded = true;
    },
  },
};
